import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Grid,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { uri } from "../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../Context/InshData";
import { GetItemFromOptions } from "../../../../services/global-services";
import RestrictionHead from "./RestrictionHead";
import RestrictionForm from "./RestrictionForm";
import RestrictionTable, { mathsTax } from "./RestrictionTable";
import RestrictionAppBar from "./RestrictionAppBar";
import clsx from "clsx";
import { insh } from "../../../../Context/InshData";
import {
    useStylesBA,
} from "../../../../St/comps/UseStyle";
import RestrictionsFooter from "./RestrictionsFooter";
import toast from "react-hot-toast";
import DeleteConfirmDialog from "../../../../components/DeleteConfirmDialog";
import SearchReaceiptContainer from "../Restrictions/RetrictionsSearch/RetrictionsSearchCon";
import { reFormatDate } from "../../../../utils/utils";
import { restrictStates } from "../../../../services/restrictionService";
import { handleSearchAccount, viewHandleAccounts } from "../../../../components/controls/AccountsSearchFinctions";
import { addArchaiveFile, addMultiArchaiveFile, handleDownloadFiles, handleMultiDownloadFiles } from "../../../Invs/BackEnd/components/SearchItemsFunction";
import RestrictionsPrint from "../../../../Reviews/Accounts/restPrint/RestrictionPrint";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#d3d3d3",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
}));

export default function Restriction(props) {
    const { AutoOptions,
        branch,
        setBranch,
        prmis,
        IsOpen,
        isDialog,
        isDialogData,
        Accounts,
    } = props;
    const [centers, setCenters] = useState(() => {
        return [{ id: -1, name: "بدون", }, ...AutoOptions?.costcenters];
    });
    const [usersSearch, setUsersSearch] = useState(() => {
        return [{ id: -1, name: "لا يوجد" }, ...Accounts?.Users ?? []];
    });
    const valuePrams = {
        id: "",
        doc_no2: AutoOptions.other.lastid,
        date: moment(new Date()).format('YYYY-MM-DD'),
        doc_no: "",
        type: IsOpen ? 11 : 10,
        state: IsOpen ? restrictStates[0].id : 1,
        notes: "",
        branch: sto.branchi,
        IS_Deleted: "",
        omla: 1,
        omlaval: 1,
        total_dept: 0,
        total_credit: 0,
        rest_type: "",
        rest_cycle_no: "",
        book_id: "",
        Center: centers[0].id,
        create_user: sto.idi,
        update_user: "",
        create_date: "",
        update_date: null,
        total_print: null,
        total_update: null,
        create_computer: null,
        update_computer: null,
    };
    const valuePramsSub = {
        no: AutoOptions.other.lastid,
        res_id: AutoOptions.other.lastid,
        dept: "",
        credit: "",
        acc_no: "",
        notes: "",
        branch: 1,
        omla: 1,
        omlaval: 1,
        omlaName: AutoOptions.omlats[0].name,
        exchange: AutoOptions.omlats[0].exchange,
        center: centers[0].id,
        ref_no: "",
        RestDate: moment(new Date()).format('YYYY-MM-DD'),
        sub_type: IsOpen ? 11 : 10,
        rest_sub_type: 1,
        acc_name: "",
        name: "",
        centerView: centers[0].name,
        editDept: false,
        editCredit: false,
        editCenter: false,
        editNotes: false,
        editRef_no: false,
        edit_acc_no: false,
        editOmla: false,
        editDate: false,
        defCenter: {},
        defAcc_no: {},
        defOmla: {},
        useTax: 0
        //srl	Tax_Type	reshd_id
    };
    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptions?.Branches);

    const valueAuto = {
        branch: valuebranch,
        book_id: AutoOptions.AccountBooks[0],
        state: restrictStates[0],
    };
    const valueAutoSub = {
        acc_no: {},
        center: centers[0],
        omla: AutoOptions.omlats[0]
    };
    const [params, setParams] = React.useState(valuePrams);
    const [paramsSub, setParamsSub] = React.useState(valuePramsSub);
    const [prevent, setPrevent] = useState(insh.prevents);
    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();

    };
    const clasBA = useStylesBA();
    const countAccounts = Accounts?.Accindex?.length === 500 ? true : false;
    const [accountsOptions, setAccountsOptions] = useState(Accounts?.Accindex);
    const [newAccountSearch, setNewAccountSearch] = React.useState([]);
    const [searchAccountText, setSearchAccountText] = useState("");
    const [paramsAuto, setParamsAuto] = React.useState(valueAuto);
    const [paramsAutoSub, setParamsAutoSub] = React.useState(valueAutoSub);
    const [paramsList, setParamsList] = React.useState([]);


    const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
    const [openSearchMdl, setOpenSearchMdl] = useState(false);
    const [rowUpdate, setRowUpdate] = useState({});

    const [openUpdate, setOpenUpdate] = useState(false);
    const [procIdSearch, setProcIdSearch] = useState(0);

    const [manualRest, setManualRest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [repeatNotes, setRepeatNotes] = useState(true);

    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const { t } = useTranslation(["forms", "translation"]);

    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);

    const his = useHistory();

    const onChangeSub = (propName) => (event) => {
        if (propName == "omlaval") {
            let omlaVal = Number(event.target.value) == 0 ? 1 : Number(event.target.value);
            setParamsSub({ ...paramsSub, [propName]: omlaVal });
        }
        else if (propName === "dept" || propName == "credit") {
            let value = event.target.value;
            if (/^\d*\.?\d*$/.test(value)) {
                const parts = value.split(".");
                if (parts[1]?.length > 4) {
                    parts[1] = parts[1].slice(0, 4);
                    value = parts.join(".");
                }
                setParamsSub({ ...paramsSub, [propName]: value });
            }
        }
        else {
            setParamsSub({ ...paramsSub, [propName]: event.target.value });
        }
    };
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const clasCAB = useStylesCAB();

    const addnewSearch = (newValue) => {
        const newSelect = Accounts?.Accindex.find((obj) => obj.id === newValue.id);
        const newSelect2 = newAccountSearch.find((obj) => obj.id === newValue.id);
        if (!newSelect && !newSelect2) {
            setNewAccountSearch([newValue, ...newAccountSearch]);
            setAccountsOptions([newValue, ...newAccountSearch, ...Accounts.Accindex]);
        } else {
            setAccountsOptions([...newAccountSearch, ...Accounts.Accindex]);
        }
        setSearchAccountText("");
    };
    const onChangeAutoSub = async (propName, newValue) => {
        if (propName === "acc_no") {
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({ ...paramsSub, [propName]: newValue.id, acc_name: newValue.name, name: newValue.name });
            addnewSearch(newValue);
        } else if (propName === "center") {
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({ ...paramsSub, [propName]: newValue.id, centerView: newValue.name });
        } else if (propName === "omla") {
            let omlaVal = newValue.exchange == "" || newValue.exchange == 0 ? 1 : newValue.exchange;
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({
                ...paramsSub, [propName]: newValue.id, omlaval: omlaVal,
                omlaName: newValue.name, exchange: newValue.exchange
            });
        } else {
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({ ...paramsSub, [propName]: newValue.id });
        }
    };

    const onChange = (propName) => (event) => {
        if (propName === "date") {
            setParams({ ...params, [propName]: event.target.value });
            setParamsSub({ ...paramsSub, RestDate: event.target.value, });
            if (paramsList.length > 0) {
                const dateDataList = paramsList.map((row, i) => {
                    return {
                        ...row,
                        RestDate: event.target.value,
                    };
                });
                setParamsList([...dateDataList]);
            }
        } else {
            setParams({ ...params, [propName]: event.target.value });
        }
    };
    const onChangeAuto = async(propName, newValue) => {
        if(propName==="branch"){
           await reBranchGets(newValue.id);
            setParamsAuto({ ...paramsAuto, [propName]: newValue });
        }else{
            setParamsAuto({ ...paramsAuto, [propName]: newValue });
            setParams({ ...params, [propName]: newValue.id });  
        }
    };
    const reBranchGets = async (branch) => {
        const tb = {
            wait: true,
            other: true,
            parms: {
                iempid: sto.empi,
                branch: branch,
                tname: IsOpen ? "rest" : "drest",
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                    setParams({
                        ...params,
                        doc_no2: res.data.other.lastid,branch:branch
                    });
            })
            .catch((error) => {
            });
    };
    const onSubmit = (e) => {
        e.preventDefault();
        // setAccountsOptions([...newAccountSearch, ...Accounts.Accindex]);

        let totalDept = Number(params.total_dept) + Number(paramsAuto.dept);
        let totaCredit = Number(params.total_credit) + Number(paramsAuto.credit);
        setParams({ ...params, total_dept: totalDept, total_credit: totaCredit })

        let notesR = paramsSub.notes;
        let newData = {
            ...paramsSub,
            // RestDate:paramsSub.RestDate==""? params.date:paramsSub.RestDate,
            dept: Number(paramsSub.dept),
            credit: Number(paramsSub.credit),
            no: paramsList.length,
        };
        if (paramsSub.acc_no == "") {

        } else if (prmis?.FORCECOST === true && paramsSub?.center < 1) {
            alert("لا يمكنك إتمام العملية برجاء التأكد من اختيار مركز التكلفة");
        }
        else {
            if (!IsOpen) {
                let acc_tax = null;
                if (parseFloat(newData.dept) > 0) {
                    acc_tax = Accounts?.MedAccount.find((x) => x.namePro === "TaxPurches");
                } else {
                    acc_tax = Accounts?.MedAccount.find((x) => x.namePro === "TaxSales");
                }
                if (paramsSub.useTax === 1 && acc_tax != null) {
                    const newData2 = {
                        ...paramsSub,
                        no: paramsList.length + 1,
                        acc_no: acc_tax.id,
                        acc_name: acc_tax.name,
                        name: acc_tax.name,
                        useTax: 0,
                        dept: Number(paramsSub.dept) > 0 ? mathsTax(Number(paramsSub.dept), parseFloat(15), "taxval") : 0,
                        credit: Number(paramsSub.dept) > 0 ? 0 : mathsTax(Number(paramsSub.credit), parseFloat(15), "taxval"),
                    };
                    setParamsList(perv => [...perv, newData, newData2]);
                } else {
                    setParamsList([...paramsList, newData]);
                }
            } else {
                setParamsList([...paramsList, newData]);
            }
            // setParamsList([...paramsList, newData]);
            if (repeatNotes) {
                setParamsSub({ ...valuePramsSub, notes: notesR, RestDate: params.date });
                setParamsAutoSub({ ...valueAutoSub })
            } else {
                setParamsAutoSub({ ...valueAutoSub })
                setParamsSub({ ...valuePramsSub, RestDate: params.date })
            }
        }
    };

    const reloadGets = async (cycle_no) => {
        const tb = {
            wait: true,
            other: true,
            parms: {
                iempid: sto.empi,
                branch: sto.branchi,
                tname: IsOpen ? "rest" : "drest",
                withOmlat: true,
                iformid: IsOpen ? "60012" : "60002",
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setParams({
                    ...valuePrams,
                    doc_no2: res.data.other.lastid,
                    date: moment(new Date()).format('YYYY-MM-DD'),
                    rest_cycle_no: cycle_no ?? 0,
                });
            })
            .catch((error) => {
            });
    };
    const timer = React.useRef();
    const [infoPrint, setInfoPrint] = useState(false);
    const [dataPrint, setDataPrint] = useState({});
    const closePrint = (type) => {
        handNewItem();
        setDataPrint({});
        setInfoPrint(false);
    };

    const ButtonSuccess = (prop, timr, data) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "print") { print(data); }
            else if (prop === "save") { handNewItem(); }
            else if (prop === "delete") { handNewItem(); }
            else {
                handNewItem();
            }
            // setPrevent(true);
        }, 2000);
    };
    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });
    const ButtonWitting = (prop) => {
        reloadGets(0);
    };
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const newToI = (timr) => {
        setIsLoading(true);
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        // setPrevent(true);
    };
    const handNewItem = () => {
        // reloadGets();
        setOpenButtonsSearch(false);
        setFiles([]);
        setOpenUpdate(false);
        if (manualRest === true && !prevent) {
            const newItems = paramsList.map((row, i) => {
                return {
                    ...row,
                    // no: i,
                    RestDate: moment(new Date()).format('YYYY-MM-DD'),
                };
            });
            setParamsList(newItems);
            getRestRecycle(true);
        } else {
            setParamsList([]);
            reloadGets(0);
        }
        // reloadGets();
        setParamsAuto(valueAuto);
        setParamsAutoSub(valueAutoSub);
        setParamsSub(valuePramsSub);
        setPrevent(true);
        setIsLoading(false);
        setAccountsOptions([...newAccountSearch, ...Accounts.Accindex]);
        if (props.isDialogData === true) {
            props.onClose();
        }
    };

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const deleteToI = async (e) => {
        if (paramsList.length > 0) {
            await e.preventDefault();
            setConfirmDialog({ ...confirmDialog, isOpen: false });
            ButtonLoading("delete");

            await axios.delete(uri + `RestrictionInsert?id=${params.id}&&branch=${params.branch}`).then(res => {
                // toast.success("Restriction has deleted");
                if (res?.data > 0) {
                    toast.success("لقد تم حذف القيد بنجاح");

                    if (props.isDialogData === true) {
                        props.onClose();
                    } else {
                        ButtonSuccess("delete", true);
                    }
                }
                else {
                    toast.error(res.data);
                    toast.error(res.data);
                    if (props.isDialogData === true) {
                        props.onClose();
                    }
                    else { ButtonSuccess("delete", true); }
                }
            }).catch(err => {
                if (err.response?.data?.Message != null) {
                    toast.error(err.response?.data?.Message);
                } else
                    console.log("eror", err)
                ButtonSuccess("delete", false);
                toast.error("not delete ")
            })
        }
    };

    const print = (data) => {
        const info = {
            data: paramsList,
            tot: null,
            type: 2,
            accBook: IsOpen ? "قيود الإفتتاحية" : "قيود يومية",
            doc_no2: data?.doc_no2 != null ? data.doc_no2 : params.doc_no2,
            notes: params.notes,
            // total_dept: params.total_dept,
            // total_credit: params.total_credit,
            total_dept: paramsList
                ?.reduce((a, v) => (a = a + parseFloat(v.dept)), 0).toFixed(2),
            total_credit: paramsList
                ?.reduce((a, v) => (a = a + parseFloat(v.credit)), 0).toFixed(2),
            branchName: GetItemFromOptions(params.branch, AutoOptions?.Branches)?.name ?? "",
            username: GetItemFromOptions(!prevent ? params?.create_user : data?.create_user ?? -1, usersSearch)?.username ?? "",
            nDate: moment(params.date).format("YYYY-MM-DD"),
            tDate: "00:00:00",
        };
        setDataPrint(info);
        setInfoPrint(true);
        // localStorage.setItem("iInfos", JSON.stringify(info));
        // his.push({ pathname: "/RP" });
        // window.location.reload(false);
    };

    const addChangds = () => {
        params.date =
            moment(params.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");
    };
    const will = () => {
        let ob = "yes";
        if (paramsList.length == 0) {
            ob = "no";
        } else {
            ob = "yes";
        }
        return ob;
    };
    const [uiElement, setUiElement] = useState({});


    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });
    const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);

    const addToBS = (propName) => {
        let action = will();
        if (paramsList.length > 0 &&
            paramsList?.reduce((a, v) => (a = a + parseFloat(v.dept)), 0).toFixed(2)
            != paramsList?.reduce((a, v) => (a = a + parseFloat(v.credit)), 0).toFixed(2)) {
            alert("قيد غير متوازن");
        } else {
            if (action == "yes") {
                addChangds();
                ButtonLoading("save");
                setIsLoading(true);
                console.log("the curre data is ", params);
                const restSub = paramsList.map((row, i) => {
                    return {
                        ...row,
                        dept: parseFloat(row.dept).toFixed(2),
                        credit: parseFloat(row.credit).toFixed(2),
                    };
                });
                const model = {
                    restriction: {
                        ...params,
                        rest_type: manualRest ? 2 : 1,
                        total_dept: paramsList?.reduce((a, v) => (a = a + parseFloat(v.dept)), 0).toFixed(2),
                        total_credit: paramsList?.reduce((a, v) => (a = a + parseFloat(v.credit)), 0).toFixed(2),
                    },
                    _Data: restSub,
                };
                prevent
                    ? axios
                        .post(uri + "RestrictionInsert", model)
                        .then((res) => {
                            if (propName === "print") {
                                ButtonSuccess("print", 500, res?.data);
                            } else {
                                toast.success("تمت عملية الحفظ بنجاح");
                                ButtonSuccess("save", 500, res?.data);
                            }
                            if (files?.length > 0) { addArchaive(); }
                        })
                        .catch((res) => {
                            if (res.response?.data?.Message != null) {
                                toast.error(res.response?.data?.Message);
                            } else
                                toast.error("خطا في عملية الحفظ");
                            ButtonSuccess("save", 1000, res?.data);
                        })
                    :
                    axios
                        .put(uri + "RestrictionInsert", model)
                        .then((res) => {
                            if (propName === "print") {
                                ButtonWitting("save", res?.data);
                                ButtonSuccess("print", 500);
                            } else {
                                toast.success("تمت عملية التعديل بنجاح");
                                ButtonWitting("save", res?.data);
                                ButtonSuccess("save", 1000, res?.data);
                            }
                            if (files?.length > 0) { addArchaive(); }
                        })
                        .catch((res) => {
                            if (res.response?.data?.Message != null) {
                                toast.error(res.response?.data?.Message);
                            } else
                                toast.error(" لم يتم عملية التعديل ");
                            setIsLoading(false);
                        });
            } else {
                alert("Please...Complete The data ");
            }
        }
    };

    const [transition, setTransition] = React.useState(undefined);
    const handCloseDw = () => {
        setOpenSearchMdl(false);
    };
    const onClickButton = async (procId, type) => {
        const tb = {
            ButtonSearchRest: true,
            parms: {
                tname: type,
                branch:paramsAuto.branch.id,
                iprocid: procId,
                type: IsOpen ? 11 : 10,
            },
        };
        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setProcIdSearch(res.data?.rest_data?.id);
                if (res.data?.rest_data.id > 0) {
                    setPrevent(false);
                    RestSubData(res.data.rest_data);
                }
            })
            .catch((error) => {
            });
    };

    const getRestRecycle = async (event) => {
        if (event === true) {
            const tb = {
                other: true,
                parms: {
                    branch: sto.branchi,
                    tname: "rest_cycle",
                },
                autos: {},
            };
            await axios
                .post(uri + "GetD", tb)
                .then((res) => {
                    // setParams({ ...params, rest_cycle_no: res.data.other.lastid });
                    reloadGets(res.data.other.lastid);
                    setManualRest(true);
                })
                .catch((error) => { });
        } else {
            setParams({ ...params, rest_cycle_no: '' });
            setManualRest(event);
        }
    }

    const FromDialog = async () => {
        if (props.isDialogData === true) {
            let data = props.invData;
            RestSubData(data);
            setPrevent(false);
        }
    };

    const RestSubData = async (data) => {
        await axios
            .get(
                uri +
                `AccountReports/RestrictionSubSearch?branch=${data?.branch}
    &&resId=${data?.id}`
            )
            .then((res) => {
                if (res.data) {
                    getRowClick({ ...data }, res?.data?.restSubData);
                } else {
                    getRowClick({ ...data }, res?.data?.restSubData);
                }

            })
            .catch((err) => {
                console.log(err);
            });

    };
    const onRowDataClick = async (row, subData) => {
        console.log("data row", row);
        getRowClick(row, subData);
        setPrevent(false);
        setOpenSearchMdl(false);
    };
    const getRowClick = (head, subData) => {
        const arr1 = new Set(Accounts.Accindex.map(x => x.id));
        const result = Array.from(
            new Map(subData
                .filter(item => !arr1.has(item.acc_no))
                .map(acc => [acc.acc_no, acc])
            ).values()
        ).map(item => ({
            id: item.acc_no,
            name: item.acc_name ?? "",
        }));
        if (result) { setNewAccountSearch(result); }
        setParamsList(
            subData.map((sub, i) => {
                const account = Accounts?.Accindex.find((obj) => obj.id === sub.acc_no);
                const centerSub = centers.find((obj) => obj.id === sub.center);
                const defOmla = AutoOptions?.omlats.find((obj) => obj.id === sub.omla);
                return {
                    ...sub,
                    name: sub.acc_name ?? account.name,
                    acc_name: sub.acc_name ?? account.name,
                    centerView: centerSub?.name,
                    omlaName: defOmla.name,
                    exchange: defOmla.exchange,
                    editDept: false,
                    editCredit: false,
                    editCenter: false,
                    editNotes: false,
                    editRef_no: false,
                    edit_acc_no: false,
                    editOmla: false,
                    editDate: false,
                    defCenter: {},
                    defAcc_no: {},
                    defOmla: {},
                    no: i,
                };
            }));

        setParams({
            ...head,
            branch: head.branch,
            date: reFormatDate(head.date),
            id: head.id,
            update_user: sto.idi,
        });
        let isManul = head?.rest_type == 2 ? true : false;
        setManualRest(isManul);
        let res = { branch: {}, book_id: {} };
        AutoOptions.AccountBooks.map((x) => {
            if (x.id == head.book_id) res.book_id = x;
        });
        AutoOptions.Branches.map((x) => {
            if (x.id == head.branch) res.branch = x;
        });

        setParamsAuto({
            ...valueAuto,
            book_id: res.book_id,
            branch: res.branch,
        })
    };


    useEffect(() => {
        FromDialog();
    }, []);

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    };
    useEffect(() => {
        if (isMobileDevice()) return;

        const handleKeyDown = async (event) => {
            //  if (event.altKey && event.key ==="p"){
            if (event.key === 'F3') {
                event.preventDefault();
                if (!prevent && !openUpdate) return;
                addToBS("save");
            }
            if (event.key === 'Shift') {
                event.preventDefault();
                setRepeatNotes(!repeatNotes);
            }
            if (event.key === 'F2') {
                event.preventDefault();
                await newToI(1000);
            }
            if (event.key === 'F7') {
                event.preventDefault();
                if (prevent) {
                    addToBS("print");
                } else {
                    if (openUpdate) {
                        addToBS("print");
                    } else {
                        print();
                    }
                }
            } if (event.key === 'F4') {
                event.preventDefault();
                if (!prevent) {
                    setOpenUpdate(true);
                }
            }
            if (event.key === 'F6') {
                event.preventDefault();
                if (!prevent) {
                    setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                            deleteToI(event, params.id, setting.screen);
                        },
                    })
                }

            }
            if (event.key === 'F9') {
                event.preventDefault();
                setOpenSearchMdl(true);
            } if (event.key === 'F8') {
                event.preventDefault();
                setOpenButtonsSearch(true);
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                if (props.isDialogData) {
                    props.onClose();
                } else {
                    backHome();
                }
            }
            else if (event.key === "Delete") {
                // event.preventDefault();
                if (!prevent && !openUpdate) return;
                if (rowUpdate.no != null) {
                    setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                            var newData = paramsList.filter((obj) => obj.no !== rowUpdate.no);
                            const newItems = newData.map((row, i) => {
                                return {
                                    ...row,
                                    no: i,
                                };
                            });
                            setParamsList([...newItems]);
                            setConfirmDialog(false);
                            setRowUpdate({});
                        },
                    })

                }
            }

        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [paramsList, params, prevent, confirmDialog, IsOpen, openSearchMdl, setting,
        , openButtonsSearch, confirmDialog, repeatNotes, openUpdate, procIdSearch, rowUpdate, props]);
    const searchTimeout = useRef(null);

    const handleInputSearchAccount = (event, newValue, reason) => {
        const allOptions = [...newAccountSearch, ...Accounts.Accindex];
        handleSearchAccount(newValue, allOptions, searchTimeout, setAccountsOptions,
            countAccounts, setSearchAccountText, reason);
    };
    const handleIconSearchAccount = () => {
        if (searchAccountText != "") {
            // if (!countAccounts && searchAccountText != "") {
            viewHandleAccounts(searchAccountText, setAccountsOptions, -1);
        }
    };
    const addArchaive = async (data) => {
        let typeF = IsOpen ? "RestrictionOpen" : "Restriction";
        let fileName = typeF + params.doc_no2 + params.branch;
        // addArchaiveFile(file, fileName);
        addMultiArchaiveFile(files, fileName);
    };
    const handleDownload = async () => {
        try {
            let typeF = IsOpen ? "RestrictionOpen" : "Restriction";
            let fileName = typeF + params.doc_no2 + params.branch;
            // await handleDownloadFiles(fileName);
            await handleMultiDownloadFiles(fileName);
        } catch (error) {
        }
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ fontWeight: "bold", fontSize: "1.4rem" }}
                    color="primary"
                >
                    {IsOpen ? "القيود الإفتتاحية" : "القيود اليومية"}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: "#808080",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    <RestrictionHead
                        {...{
                            paramsAuto,
                            params,
                            onChange,
                            onChangeAuto,
                            AutoOptions,
                            manualRest,
                            setManualRest,
                            repeatNotes,
                            setRepeatNotes,
                            IsOpen,
                            handleDownload,
                            setFile,
                            prevent,
                            prmis,
                            getRestRecycle,
                            setFiles,
                            files
                        }}
                    />

                </Container>
                {/* <br /> */}
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: "#808080",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                        marginTop: "0.5rem"
                    }}
                >
                    <RestrictionForm
                        {...{
                            onChangeSub,
                            onChangeAutoSub,
                            paramsAutoSub,
                            AutoOptions,
                            onSubmit,
                            paramsSub,
                            centers,
                            prevent,
                            openUpdate,
                            IsOpen,
                            handleInputSearchAccount,
                            handleIconSearchAccount,
                            searchAccountText,
                            accountsOptions,
                            setParamsSub
                        }}
                    />

                </Container>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        paddingBottom: "0px",
                        borderBottomColor: "#808080",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                        marginTop: "0.5rem"
                    }}
                >
                    <Grid container justifyContent="center">
                        <Grid item container justifyContent="center" xs={12}>
                            <RestrictionTable
                                {...{
                                    paramsList, setParamsList, AutoOptions, setConfirmDialog,
                                    prevent, openUpdate, centers, Accounts, setRowUpdate, IsOpen, handleIconSearchAccount
                                    , searchAccountText, handleInputSearchAccount, accountsOptions, addnewSearch
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>

                <RestrictionsFooter
                    {...{
                        paramsList,
                        params,
                        total_dept: paramsList
                            ?.reduce((a, v) => (a = a + parseFloat(v.dept)), 0).toFixed(2)
                        ,
                        total_credit: paramsList
                            ?.reduce((a, v) => (a = a + parseFloat(v.credit)), 0).toFixed(2)
                        // .toFixed(5)
                    }}
                />


            </Typography>

            <RestrictionAppBar {...{
                ...props,
                params,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent,
                paramsList,
                isLoading,
                setConfirmDialog,
                openButtonsSearch,
                setOpenButtonsSearch,
                procIdSearch,
                onClickButton,
                setOpenSearchMdl,
                openUpdate,
                setOpenUpdate,
                print
            }}
            />
            {openSearchMdl && (
                <SearchReaceiptContainer
                    {...{
                        openSearchMdl, handCloseDw,
                        onRowDataClick, type: IsOpen ? 11 : 10, AutoOptions, transition, usersSearch
                    }}
                />
            )}

            <DeleteConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            {infoPrint ? <RestrictionsPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}

        </div>
    );
}
